<template>
  <FormLabel :text="text" :error="error">
    <input class="aoformfield" :placeholder="placeholder"
           type="email" 
           :disabled="$store.state.loading"
           :name="name"
           @blur="filledCheck"
           v-model="val">
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'

export default {
  components: { FormLabel },
  mixins: [FormField],
  props: {
    name: {type: String, required: true},
    value: {type: String, default: ''},
    text: {type: String, required: true},
    placeholder: {type: String},
    validation: {type: Function, default: ()=>''},
    filled: {type: Function, default: (v)=>v?true:false}
  },
  data: ()=>({
    error: '',
    collector: {}
  }),
  mounted(){
    if (this.$parent.fieldsStatus)
      this.collector = this.$parent.fieldsStatus
    else if (this.$parent.$parent.fieldsStatus)
      this.collector = this.$parent.$parent.fieldsStatus

    if (this.collector)
      this.collector[this.name] = false
  },
  methods:{
    isValidEmail(email){
      return email.toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },
    filledCheck(){
      if (!this.filled(this.value)) {
        this.error = "Заполните поле"
        this.collector[this.name] = false
      }
    }
  },
  computed:{
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  watch: {
    value(newVal){
      if (!this.isValidEmail(newVal))
        this.error = 'Некорректный email'
      else
        this.error = this.validation(newVal)
      if (this.error || !this.filled(newVal))
        this.collector[this.name] = false
      else
        this.collector[this.name] = true            
    }
  }
}
</script>

<style lang="sass">

</style>